// Port of api/fuel/app/classes/filter/search/games/rules/query/play_location.php
import Rule from 'offline/filter/core/search/rule'
import DB from 'offline/db'
import Util from 'offline/util'

function textInIndex(values) {
	var index = []
	for (var i = 0; i < values.length; i++) {
		var value = String(values[i]).toLowerCase().replace(/'/g, "''")
		index.push("'" + value + "'")
		index.push("'" + value.replace(/-/g, ' ') + "'")
	}
	return index.join(',')
}

export default Rule.create({
	name: 'play_location',
	isIndex: function() { return true },
	field: function() { return 'g.game_id' },
	oneof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('g.game_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT DISTINCT game_id FROM play WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(play_location) IN(' + textInIndex(values) + ')'
		), 'game_id')

		var result = Rule.setFilter(rule, 'one', ids)
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where('g.game_id', opMap, result)
	},
	someof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('g.game_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT game_id FROM play WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(play_location) IN(' + textInIndex(values) + ')'
		), 'game_id')

		query.where('g.game_id', 'in', Rule.setFilter(rule, 'some', ids))
	},
	allof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('g.game_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT game_id FROM play WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(play_location) IN(' + textInIndex(values) + ')'
		), 'game_id')

		query.where('g.game_id', 'in', Rule.setFilter(rule, 'all', ids))
	},
	match: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('g.game_id', '=', 0); return }

		var ids = Util.pluck(DB.query(
			'SELECT DISTINCT game_id FROM play WHERE user_id IN(' + Util.in(data.users) + ') AND LOWER(play_location) IN(' + textInIndex(values) + ')'
		), 'game_id')

		var result = Rule.setFilter(rule, 'one', ids)
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where('g.game_id', opMap, result)
	}
})
